module.exports = __webpack_public_path__ + "img/emale-logo.c3efdc36.svg";